export default "__VITE_ASSET__DWAbSBlh__"